export default __webpack_public_path__ + "static/media/t-shirt.791c9589.svg";